import type { ApiCommunications } from '../../webmodule-common/interop/interfaces/api-communications';
import type { FranchiseeClientApi } from './franchisee-client-api';
import type {
  InputCreateFranchiseeClient, InputUpdateClientDefaults,
  RequestGetClientDefaultPaymentProfileById,
  RequestGetFranchiseeClientListByIds,
  ResultCreateFranchiseeClient,
  ResultGetClientDefaultPaymentProfileById,
  ResultGetFranchiseeClientListByIds,
  ResultUpdateFranchiseeClient
} from './dealer-api-interface-franchisee';
import type { NullPromise } from '../../webmodule-common/interop/types/misc';

export class FranchiseeClientApiImplementation implements FranchiseeClientApi {
  private readonly api: ApiCommunications;
  private readonly baseRoute = 'api/Franchisee/';

  constructor(api: ApiCommunications) {
    this.api = api;
  }

  private post<T>(endpoint: string, body: unknown): NullPromise<T> {
    return this.api.post<T>(`${this.baseRoute}${endpoint}`, body);
  }

  async createFranchiseeClient(body: InputCreateFranchiseeClient): NullPromise<ResultCreateFranchiseeClient> {
    return this.post<ResultCreateFranchiseeClient>('CreateFranchiseeClient', body);
  }

  async updateFranchiseeClient(body: InputUpdateClientDefaults): NullPromise<ResultUpdateFranchiseeClient> {
    return this.post<ResultUpdateFranchiseeClient>('UpdateFranchiseeClient', body);
  }

  async getClientDefaultPaymentProfileById(
    body: RequestGetClientDefaultPaymentProfileById
  ): NullPromise<ResultGetClientDefaultPaymentProfileById> {
    return this.post<ResultGetClientDefaultPaymentProfileById>('GetClientDefaultPaymentProfileById', body);
  }

  async getFranchiseeClientListByIds(
    body: RequestGetFranchiseeClientListByIds
  ): NullPromise<ResultGetFranchiseeClientListByIds> {
    return this.post<ResultGetFranchiseeClientListByIds>('GetFranchiseeClientListByIds', body);
  }
}